import React, { cloneElement, useState } from 'react';
import PropTypes from 'prop-types';
import {
  TopToolbar,
  ExportButton,
  sanitizeListRestProps,
  useListContext,
} from 'react-admin';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CreateCleanerDialog from './CreateCleanerDialog';

const CleanerListActions = (props) => {
  const { className, filters, ...rest } = props;
  const {
    displayedFilters,
    filterValues,
    showFilter,
    currentSort,
    total,
  } = useListContext();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {filters &&
        cloneElement(filters, {
          resource: 'cleaner',
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <Button
        color="primary"
        size="small"
        startIcon={<AddIcon />}
        onClick={() => {
          return setDialogOpen(true);
        }}
      >
        Créer
      </Button>
      <ExportButton
        disabled={total === 0}
        resource="cleaner"
        sort={currentSort}
        filterValues={filterValues}
      />
      <CreateCleanerDialog
        open={dialogOpen}
        onClose={() => {
          return setDialogOpen(false);
        }}
      />
    </TopToolbar>
  );
};

CleanerListActions.propTypes = {
  className: PropTypes.string,
  filters: PropTypes.element,
};

CleanerListActions.defaultProps = {
  className: undefined,
  filters: undefined,
};

export default CleanerListActions;
